import 'css-chunksrc/client/scenes/projectListingConfiguration/form/styles.scss';export default {
  "form": "_form_6lrs7_1",
  "group": "_group_6lrs7_5",
  "row": "_row_6lrs7_9",
  "label": "_label_6lrs7_19",
  "description": "_description_6lrs7_24",
  "roleSelection": "_roleSelection_6lrs7_28"
};